import React from 'react';
import configService from '../../services/config.service';
import { useTranslation } from 'react-i18next';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const companyName = configService.appName();
  const version = configService.appVersion();
  const { t } = useTranslation('common');

  return (
    <div className="text-center my-3">
      <p className="flex justify-center dark:text-white">
        <span className="w-full">
          Copyright &copy; {currentYear} {companyName}.{' '}
          {t('all_rights_reserved')}
        </span>
        <span className="ml-auto">{version && `${version}`}</span>
      </p>
    </div>
  );
};

export default Footer;
